var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBzFire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.71 62.68c5.82-3.68 5.43-13.45.48-17.06a11.229 11.229 0 01-7.91 5.76 9.09 9.09 0 00.86-11.84c-1.76 5.74-10.74 6.32-10 14.28.38 4 3.84 7.64 7.51 9.18-9.16-1.26-17.19-5.64-16.35-16.93 1.09-14.56 19.24-17 14.91-33.94 8.88 2.65 14.9 11.58 13.42 25.08a9 9 0 004.7-7.27c9.91 10.12 9.08 27.18-7.62 32.74z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/BZ_Fire.9d581297.svg";
export { SvgBzFire as ReactComponent };